
export  {images}

const images = 
   [
    {
      alt: 'Description de l\'image 1',
      src: './assets/imgBasse/basse1.webp',
      title: 'Titre de l\'image 1'
    },
    {
      alt: 'Description de l\'image 2',
      src: './assets/imgBasse/basse2.webp',
      title: 'Titre de l\'image 2'
    },
    {
      alt: 'Description de l\'image 3',
      src: './assets/imgBasse/basse3.webp',
      title: 'Titre de l\'image 3'
    },
    {
      alt: 'Description de l\'image 4',
      src: './assets/imgBasse/basse4.webp',
      title: 'Titre de l\'image 4'
    },
    {
      alt: 'Description de l\'image 5',
      src: './assets/imgBasse/basse5.webp',
      title: 'Titre de l\'image 5'
    },
    {
      alt: 'Description de l\'image 6',
      src: './assets/imgBasse/basse6.webp',
      title: 'Titre de l\'image 6'
    },
    {
      alt: 'Description de l\'image 7',
      src: './assets/imgBasse/basse7.webp',
      title: 'Titre de l\'image 7'
    },
    {
      alt: 'Description de l\'image 8',
      src: './assets/imgBasse/basse8.webp',
      title: 'Titre de l\'image 8'
    },
    {
      alt: 'Description de l\'image 9',
      src: './assets/imgBasse/basse9.webp',
      title: 'Titre de l\'image 9'
    },
    {
      alt: 'Description de l\'image 9',
      src: './assets/imgBasse/basse10.webp',
      title: 'Titre de l\'image 9'
    },
    // ... Ajoutez d'autres objets d'image avec leurs propriétés
  ];
  export default images;